import { ChainlinkIcon } from "@src/assets/icons";

export const PoweredBy = () => {
  return (
    <div className="flex justify-center items-center gap-2 my-3">
      <span className="text-t_text_primary opacity-50">Powered by</span>
      <div className="flex items-center gap-1 fill-t_chainlink_logo">
        <ChainlinkIcon />
      </div>
    </div>
  );
};
